
export const TableHeader = ({children}) => {

    return (
        <thead>
            {children}
        </thead>
    )
}